import { render, staticRenderFns } from "./PartnersHome.vue?vue&type=template&id=09a8f94b"
import script from "./PartnersHome.vue?vue&type=script&lang=js"
export * from "./PartnersHome.vue?vue&type=script&lang=js"
import style0 from "./PartnersHome.vue?vue&type=style&index=0&id=09a8f94b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports